import PropTypes from 'prop-types'
import { useState } from 'react'
import { useRouter } from 'next/router'
import MsjBrowser from 'components/MsjBrowser'
import { useTheme } from 'styled-components'
import { removeDomainFromLink } from 'utils'

import { StyledButtonContainer, StyledButton, StyledButtonOutlined, StyledLoader, StyledTextBefore, StyledTextAfter } from './styles'

const LinkButton = ({ children, dataGa, disabled, id, href, msjBrowser, outline, target, flat, beforeText, afterText, themeInfos}) => {
  const [isBrowserOpen, setIsBrowserOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const theme = useTheme()
  const router = useRouter()

  const getStyle = () => {
    if (theme && theme.button_outlined_as_default) {
      return outline ? StyledButton : StyledButtonOutlined
    }
    return outline ? StyledButtonOutlined : StyledButton
  }

  const ButtonStyle = getStyle()

  return (
    <StyledButtonContainer>
      {beforeText && <StyledTextBefore>{beforeText}</StyledTextBefore>}
      {!!msjBrowser ? (
        <ButtonStyle
          id={id}
          data-dataga={dataGa || 'link button'}
          className={disabled ? 'disabled' : ''}
          onClick={(e) => {
            e.preventDefault()
            setIsBrowserOpen(!isBrowserOpen)
          }}
          $flat={flat || false}
          $themeCustom={themeInfos}
        >
          <label>{children}</label>
        </ButtonStyle>
      ) : (
        <ButtonStyle
          id={id}
          href={href && removeDomainFromLink(href, router.query.appId, router.asPath)}
          target={target}
          data-dataga={dataGa || 'link button'}
          className={loading || disabled ? 'disabled' : ''}
          onClick={() => setLoading(true)}
          $flat={flat || false}
          $themeCustom={themeInfos}
        >
          {loading && <StyledLoader />}
          <label>{children}</label>
        </ButtonStyle>
      )}
      {afterText && <StyledTextAfter>{afterText}</StyledTextAfter>}

      <MsjBrowser isOpen={isBrowserOpen} onClose={() => setIsBrowserOpen(false)} src={href} />
    </StyledButtonContainer>
  )
}

LinkButton.propTypes = {
  backBtn: PropTypes.bool,
  children: PropTypes.node,
  dataGa: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  href: PropTypes.string,
  msjBrowser: PropTypes.bool,
  outline: PropTypes.bool,
  target: PropTypes.string,
  variant: PropTypes.string,
  flat: PropTypes.bool,
  beforeText: PropTypes.string,
  afterText: PropTypes.string,
  themeInfos: PropTypes.object,
}

export default LinkButton
